import { useNavigate, useLocation } from 'react-router-dom';
import llm from '../lib/llm';
import { useEffect, useState } from 'react';
import { useCustomEventListener } from 'react-custom-events';

export default function ShareTarget() {
  const [finished, setFinished] = useState<boolean>(false);
  const [status, setStatus] = useState<string>('Article is being summarized');
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  

  useCustomEventListener('status',
    (data) => {
      console.log(`Status: ${data}`);
    }
  );

  useEffect(() => {
    const summarize = async () => {
      const url = queryParams.get('url') || '';
      console.log('Received url:', url);
      const summaryResult = await llm.summarizeUrl(url);
      if (summaryResult.success) {
        setStatus(`Summarized article: ${summaryResult.title}`);
      }
      else {
        setStatus(`${summaryResult.error}`);
      }
      setFinished(true);
    };
    if (!finished) {
      summarize();
    }
  });

  return (
    <div>
      <div className="flex justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold">{status}</h1>

          <button type="button" onClick={() => navigate('/')} className="btn-add mt-4">
            Return
          </button>
        </div>
      </div>
    </div>
  );
}